/* eslint-disable */
// webview link
const FAQURL = 'https://s3.amazonaws.com/kargoe-docs/kargoe-faq.pdf'
const PRIVACYURL = 'https://s3.amazonaws.com/kargoe-docs/kargoe-privacy.pdf'
const TERMURL = 'https://s3.amazonaws.com/kargoe-docs/kargoe-terms.pdf'
const IOSURL = 'https://s3.amazonaws.com/kargoe-docs/kargoe-ios-terms.pdf'
const ANDROIDURL = 'https://s3.amazonaws.com/kargoe-docs/kargoe-android-terms.pdf'

// payment methods
const PAYMENT_METHOD_PAYPAL = 'PAYPAL'
const PAYMENT_METHOD_CREDIT_CARD = 'CREDIT_CARD'
const PAYMENT_METHOD_TOKENS = 'TOKENS'

// routes
const Routes = ["home", "camera",
    "explora", "messages", "kargoelytics",
    "happening", 'profile', 'settings'];
export {
    Routes,
    FAQURL,
    PRIVACYURL,
    TERMURL,
    IOSURL,
    ANDROIDURL,
    PAYMENT_METHOD_PAYPAL,
    PAYMENT_METHOD_CREDIT_CARD,
    PAYMENT_METHOD_TOKENS
}

export const MEDIA_TYPE = {
    JPEG: "JPEG",
    MP4: "MP4",
    TITL: "3D"
}
export const MEDIA_TYPES = [MEDIA_TYPE.JPEG, MEDIA_TYPE.MP4, MEDIA_TYPE.TITL]

export const VIEW_MODE = {
    GRID: 'grid',
    SINGLE: 'list'
}

export const POST_TYPE = {
    STANDARD: 0,
    LINKED: 1,
    VIDEO_LINKED: 2
}

export const USER_KIND = {
  STANDARD: 100,
  STANDARD_FULL: 120,
  AGENCY: 200,
  MERCHANT: 300,
  MERCHANT_STAFF: 301,
  MERCHANT_PENDING: 310,
  CHARITY: 400,
  CHARITY_PENDING: 410,
}

export const LANG_SELECTOR = [
  {Title: "English", Index: 0, Id: "en", Name: "English"},
  {Title: "Portuguese", Index: 1, Id: "pt", Name: "Portuguese"}
]

// released cities Oct 10, 2019
// italy, new zealand, sweden, brazil, germany, norway, canada, denmark, s. korea, spain, uk, australia, france, iceland, israel, us, vietnam


export const CURRENCY_SELECTOR = [
//  {Title: "Australian dollar", Index: 0, Id: "AUD", Name: "AUD"},
  {Title: "Brazilian Real", Index: 0, Id: "BRL", Name: "BRL"},
  {Title: "Canadian Dollar", Index: 1, Id: "CAD", Name: "CAD"},
  {Title: "Danish Krone", Index: 2, Id: "DKK", Name: "DKK"},
  {Title: "European Union Euro", Index: 3, Id: "EUR", Name: "EUR"}, // italy
/*
  {Title: "Israeli new shekel", Index: 6, Id: "ILS", Name: "ILS"},
  {Title: "New Zealand Dollar", Index: 7, Id: "NZD", Name: "NZD"},
  {Title: "Norwegian krone", Index: 8, Id: "NOK", Name: "NOK"},
  {Title: "Swedish krona", Index: 10, Id: "SEK", Name: "SEK"},
*/
  {Title: "UK Pound sterling", Index: 4, Id: "GBP", Name: "GBP"},
  {Title: "United States Dollar", Index: 5, Id: "USD", Name: "USD"},
]

export const CURRENCY_SHORTCODES = {
  "AUD": "$",
  "BRL": "R$",  
  "CAD": "$",
  "DKK": "Kr.",
  "EUR": "€",
  "GBP": "£",
  "ILS": "₪",
  "ISK": "kr ",
  "KRW": "₩",
  "NOK": "kr ",
  "NZD": "$",
  "SEK": "kr ",
  "USD": "$",
  "VND": "₫",
}
